import { Link, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { AuthProvider, useAuth } from "./AuthContext";
import { AccountSheet } from "./components/AccountSheet";
import { btnShu } from "./components/Cram";
import { Logo } from "./components/Logo";
import { Loading } from "./ui";

function Header() {
  const [, setParams] = useSearchParams();
  return (
    <header className="border-b-2 border-ink bg-paper">
      <div className="mx-auto flex max-w-2xl items-center justify-between gap-2 px-4 py-2.5">
        <Link to="/app">
          <Logo />
        </Link>
        <button
          type="button"
          onClick={() => setParams({ account: "1" })}
          className="border-2 border-ink bg-sheet px-2.5 py-1 text-[12px] font-bold hover:bg-marker"
        >
          アカウント
        </button>
      </div>
    </header>
  );
}

function Gate() {
  const { session, loading, error, signIn } = useAuth();
  const fullscreen = useLocation().pathname.startsWith("/app/p/");
  const [params, setParams] = useSearchParams();
  const fromCheckout = params.get("checkout") === "success";
  if (loading)
    return (
      <div className="grid min-h-screen place-items-center bg-paper">
        <Loading />
      </div>
    );
  if (error && !session)
    return (
      <div className="grid min-h-screen place-items-center bg-paper px-6 text-center text-[13px] font-bold text-shu">
        {error}
      </div>
    );
  if (!session)
    return (
      <div className="grid min-h-screen place-items-center bg-paper px-4">
        <div className="w-full max-w-sm border-2 border-ink bg-sheet">
          <div className="px-5 py-6">
            <Logo sub="RSVP SPEAKING DRILL" />
            <p className="mt-4 font-mincho text-[15px] font-bold">
              <span className="marker">目は一点、声は前へ。</span>
            </p>
            <button type="button" onClick={signIn} className={`${btnShu} mt-6 w-full`}>
              Google でサインイン
            </button>
          </div>
        </div>
      </div>
    );
  if (fullscreen)
    return (
      <div className="min-h-screen bg-sheet text-ink">
        <Outlet />
      </div>
    );
  return (
    <div className="min-h-screen bg-paper text-ink">
      <Header />
      <main className="mx-auto max-w-2xl px-4 py-6">
        <Outlet />
      </main>
      <AccountSheet
        open={params.get("account") === "1" || fromCheckout}
        fromCheckout={fromCheckout}
        onClose={() => setParams({}, { replace: true })}
      />
    </div>
  );
}

export function AppLayout() {
  return (
    <AuthProvider>
      <Gate />
    </AuthProvider>
  );
}
